import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { DrbState, LoadDrbByVersion, LoadDrbVersions } from 'src/app/features/drbs/redux';
import { PAYLOAD_TYPES } from 'src/app/shared/constants/general-constants';
import { TimestampDatePipe } from 'src/app/shared/pipes/timestamp-date.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { PreviewContentComponent } from 'src/app/shared/ui/preview-content/preview-content.component';
import { ENVIRONMENT } from 'src/environments/environment';
import { DrbService } from '../../../drbs/services/drb.service';

@Component({
  selector: 'app-view-content',
  templateUrl: './view-content.component.html',
  styleUrls: ['./view-content.component.css'],
  standalone: true,
  imports: [SharedModule],
  providers: [TimestampDatePipe]
})
export class ViewContentComponent implements OnInit, OnDestroy {
  public version$: Observable<any> = inject(Store).select(DrbState.versions);
  public marketing$: Observable<any> = inject(Store).select(DrbState.marketing);
  public marketing_translations$: Observable<any> = inject(Store).select(DrbState.marketing_translations);
  private unsubscribe: Subject<void> = new Subject();

  public content;

  public localeDisplays: string[] = [];

  public formatted_created_time = '';
  public formatted_updated_date = '';

  public marketing = { version: undefined };
  public marketing_translations = { version: undefined };

  constructor(
    protected ref: NbDialogRef<ViewContentComponent>,
    private formatDatePipe: TimestampDatePipe,
    private dialogService: NbDialogService,
    private drbService: DrbService,
    private store: Store
  ) {
    ENVIRONMENT.bundleNames.forEach((bundle_name) => {
      if (this.store.selectSnapshot(DrbState.versions)[bundle_name].length === 0) {
        this.store.dispatch(new LoadDrbVersions(bundle_name));
      }
    });
  }

  public ngOnInit() {
    this.handleDate();
    this.marketing$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.marketing = data));
    this.marketing_translations$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => (this.marketing_translations = data));
    this.version$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      ENVIRONMENT.bundleNames.forEach((bundle_name) => {
        if (data[bundle_name].length > 0) {
          const versions = [...data[bundle_name]].reverse();
          if (!this.store.selectSnapshot(DrbState.getByKey(bundle_name)).version) {
            this.store.dispatch(new LoadDrbByVersion(versions[0], bundle_name));
          }
        }
      });
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public formatDate = (time) => {
    const formatted_time = this.formatDatePipe.transform(time, 'timestampToDate');
    if (formatted_time) {
      return formatted_time;
    } else {
      return '';
    }
  };

  public handleDate() {
    const created_date = this.content.created_dttm;
    this.formatted_created_time = this.formatDate(created_date);

    const updated_date = this.content.last_updated_dttm;
    this.formatted_updated_date = this.formatDate(updated_date);
  }

  public close() {
    this.ref.close();
  }

  public previewContent() {
    const drbIds = PreviewContentComponent.getDrbIds(this.content);
    if (drbIds.length === 0) {
      this.dialogService.open(PreviewContentComponent, {
        closeOnEsc: true,
        closeOnBackdropClick: true,
        context: {
          content: this.content,
          values: [],
          isSpecialOffer: this.content.payload_records[0]?.payload_record_type === PAYLOAD_TYPES.PERSONALIZED_OFFER
        }
      });
    } else {
      const data = this.drbService.getDrbValues(drbIds);
      if (data != null) {
        this.dialogService.open(PreviewContentComponent, {
          closeOnEsc: true,
          closeOnBackdropClick: true,
          context: {
            content: this.content,
            values: data,
            isSpecialOffer: this.content.payload_records[0]?.payload_record_type === PAYLOAD_TYPES.PERSONALIZED_OFFER
          }
        });
      }
    }
  }
}
